import React, { useState } from "react";
import DashboardNav from "./DashboardNav/DashboardNav";
import DashboardSidebar from "./DashboardSidebar/DashboardSidebar";
import BreadCrumb from "./DashboardBreadcrumb/BreadCrumb";

const Dashboard = (props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen w-full bg-zinc-50 dark:bg-zinc-950 overflow-hidden font-sans">
      {/* Sidebar */}
      <DashboardSidebar
        sidebarButtons={props.sidebarButtons}
        isVisible={isSidebarOpen}
        closeMobileSidebar={() => setIsSidebarOpen(false)}
      />

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div 
          onClick={() => setIsSidebarOpen(false)}
          className="fixed inset-0 z-30 bg-black/40 backdrop-blur-sm lg:hidden"
        ></div>
      )}

      {/* Main Content Area */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        {/* Top Navbar */}
        <DashboardNav toggleSidebar={toggleSidebar} />

        {/* Scrollable Content */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-6 lg:p-8">
          {/* We allow the content to stretch fully or restrict it to a very wide max, 
              removing the double-card and excessive centering padding */}
          <div className="w-full h-full flex flex-col">
            <div className="mb-6">
              <BreadCrumb />
            </div>
            
            {/* The actual page content is passed as children. 
                Individual pages (like AdminPaintsList) use DashboardContainer 
                which already provides the card styling. */}
            <div className="flex-1">
              {props.children}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
